import { compose } from 'recompose'

import withResumeFlow from 'components/HOCs/WithResumeFlow'
import { withFlowRouter } from 'utils/FlowProvider'
import { withOptimizely } from 'utils/Optimizely'

export const enhance = compose<{}, {}>(withFlowRouter, withOptimizely, withResumeFlow)
